import { A2matFiltersService } from './a2mat-filters.service';
import { Component, OnInit, Output, Input, EventEmitter, TrackByFunction, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { a2MatFilterDialog } from './filter-dialog/filter-dialog.component';
import { Filter, FilterType, QuickFilter } from './filter.model'

@Component({
  selector: 'a2mat-filters',
  templateUrl: './a2mat-filters.component.html',
  styleUrls: ['./a2mat-filters.component.scss']
})
export class A2matFilters implements OnInit {
  @Output() filterChange = new EventEmitter<any>();
  @Input() filters: Array<Filter>;
  @Input() TEXTS: any = {};
  quickFilters: Array<Filter> = [];

  constructor(
    public dialog: MatDialog,
    private filterService: A2matFiltersService
  ) {
  }

  ngOnInit(): void {
    this.TEXTS.NEW = 'NEW_FILTER';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.filters){
      this.setQuickFilters(changes.filters.currentValue)
    }
  }

  setQuickFilters(filters){
    this.quickFilters = filters.filter(filter=> filter.quicks);
  }

  removeFilter(filter){
    filter.selected =  null;
    this.filterChange.emit(filter);
  }

  filterSelected(filter) {
    const dialogRef = this.dialog.open(a2MatFilterDialog, {
      data: filter,
    });

    dialogRef.afterClosed().subscribe(rFilter => {
      if (rFilter) {
        this.filterChange.emit(filter);
      }
    });
  }

  onQuickFilter(filter: Filter, quick:QuickFilter){
    const selection = filter.options.find(option => option.id === quick.id)
    this.filterService.setSelection(filter, selection);
    this.filterChange.emit(filter);
  }

}
